import React from 'react'
import Header from "../../components/header/index";
import InnerHeader from "../../components/comment/innerHeader/innerHeader";
import VerifiedDocumentContent from './content/verifiedDocumentsContent';
import Footer from "../../components/footer";

const index = () => {
  return (
    <div className="main">
      <Header />
      <InnerHeader title="Verification Document Upload " />
      <VerifiedDocumentContent />
      <Footer />
    </div>
  )
}

export default index